import Vue from "vue";

export async function setConfiguracionVuex({ commit }, configuracion) {
  //console.log("Guardando configuración en vuex...");
  commit("setConfiguracion", configuracion);
}

export async function getConfiguracionApi({ commit }, userLogin) {
  try {
    let ruta = Vue.prototype.$apiRoute + "expedicionRapida/" + userLogin;
    let res = await fetch(ruta, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });
    let resJson = await res.json();
    return {
      estado: res.ok,
      respuesta: resJson
    };
  } catch (error) {
    return {
      estado: false,
      respuesta: {}
    };
  }
}

export async function crearConfiguracionApi({ commit }, userLogin) {
  try {
    let ruta = Vue.prototype.$apiRoute + "expedicionRapida/" + userLogin + "/nuevo";
    let res = await fetch(ruta, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });
    let resJson = await res.json();
    return {
      estado: res.ok,
      respuesta: resJson
    };
  } catch (error) {
    return {
      estado: false,
      respuesta: "Error"
    };
  }
}

export async function eliminarConfiguracionApi({ commit }, userLogin) {
  try {
    let ruta = Vue.prototype.$apiRoute + "expedicionRapida/" + userLogin;
    let res = await fetch(ruta, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });
    let resJson = await res.json();
    return {
      estado: res.ok,
      respuesta: resJson
    };
  } catch (error) {
    return {
      estado: false,
      respuesta: "Error"
    };
  }
}


export async function guardarConfiguracionApi({ commit }, payload) {
  try {
    let ruta = Vue.prototype.$apiRoute + "expedicionRapida/" + payload.userLogin;
    let res = await fetch(ruta, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(payload.configuracion)
    });
    let resJson = await res.json();
    return {
      estado: res.ok,
      respuesta: resJson
    };
  } catch (error) {
    return {
      estado: false,
      respuesta: "Error"
    };
  }
}
